import React, { type ComponentType } from 'react'
import { withAuthenticationRequired } from '@auth0/auth0-react'
import PageLoader from './page-loader'

interface AuthenticationGuardProps {
  Component: ComponentType<any>
  [key: string]: any
}

const AuthenticationGuard: React.FC<AuthenticationGuardProps> = ({
  Component, ...props
}) => {
  const TransitionComponent: React.FC<React.ComponentProps<typeof Component>> = withAuthenticationRequired(Component, {
    onRedirecting: () => (
      <div style={{ width: '100%', height: '100%', backgroundColor: '#121212' }}>
        <PageLoader/>
      </div>
    ),
  })

  return <TransitionComponent {...props}/>
}

export default AuthenticationGuard
